(function () {
  const settings = window.SYRINX_RESTOCK_SETTINGS;

  if (!settings) return;

  function updateBackInStockVisibility(variantId) {
    const appBlocks = document.querySelectorAll('.my-custom-restock-wrapper');

    if (!appBlocks.length) return;

    const isVariantHidden = settings.variantRules[variantId] === true;
    const shouldHide = settings.hasGlobalTag || isVariantHidden;

    console.log(
      `BackInStock制御: Variant ID ${variantId} -> Hide? ${shouldHide} (対象数: ${appBlocks.length})`
    );

    appBlocks.forEach(block => {
      if (shouldHide) {
        block.setAttribute('data-hide-app', 'true');
      } else {
        block.removeAttribute('data-hide-app');
      }
      block.style.visibility = "visible";
    });
  }

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;
    if (variant) {
      updateBackInStockVisibility(variant.id);
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    const currentVariantId = window.SYRINX_RESTOCK_SETTINGS.initialVariantId;
    updateBackInStockVisibility(currentVariantId);
  });
})();